import React, { useEffect, useState } from "react";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import { Icon, initialsOf } from "./icons";
import "./admin.css";

const API =
  process.env.REACT_APP_API_URL || "https://backend-9i6n.onrender.com";

const MENU = [
  { path: "/admin/dashboard", name: "डॅशबोर्ड", icon: Icon.dashboard },
  { path: "/admin/notices", name: "सूचना", icon: Icon.bell },
  { path: "/admin/services", name: "सेवा अर्ज", icon: Icon.doc, badge: true },
  { path: "/admin/schemes", name: "योजना", icon: Icon.building },
  { path: "/admin/development", name: "विकास कामे", icon: Icon.tool },
  { path: "/admin/gallery", name: "छायाचित्रे", icon: Icon.image },
  { path: "/admin/contact", name: "सदस्य", icon: Icon.people },
  { path: "/admin/about", name: "गावाची माहिती", icon: Icon.info },
];

const getGreeting = () => {
  const h = new Date().getHours();
  if (h < 12) return "सुप्रभात";
  if (h < 18) return "नमस्कार";
  return "शुभ संध्या";
};

const AdminLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [pendingCount, setPendingCount] = useState(0);

  const token = localStorage.getItem("token");

  useEffect(() => {
    let cancelled = false;

    const fetchPending = async () => {
      try {
        const res = await fetch(`${API}/api/admin/services`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) return;
        const data = await res.json();
        if (cancelled) return;
        const pending = Array.isArray(data)
          ? data.filter((s) => s.status?.toLowerCase() === "pending").length
          : 0;
        setPendingCount(pending);
      } catch {
        /* badge just stays 0 if this fails */
      }
    };

    fetchPending();
    return () => {
      cancelled = true;
    };
  }, [location.pathname, token]);

  const isActive = (path) => location.pathname === path;
  const currentPage = MENU.find((item) => item.path === location.pathname);

  const handleLogout = () => {
    if (window.confirm("आपण लॉगआउट करणार आहात का?")) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      navigate("/login");
    }
  };

  return (
    <div className="admin-container">
      <div className="admin-topstripe">
        <span /><span /><span />
      </div>

      <div className="admin-body">
        {/* ============ SIDEBAR ============ */}
        <aside className={`admin-sidebar ${isSidebarOpen ? "open" : "closed"}`}>
          <div className="sidebar-brand">
            <div className="sidebar-logo-box">रोशणखेडा GP</div>
            <div className="sidebar-village">
              <div className="sidebar-village-name">रोशणखेडा ग्रामपंचायत</div>
              <div className="sidebar-village-tag">प्रशासन पॅनल</div>
            </div>
          </div>

          <div className="sidebar-profile">
            <div className="sidebar-profile-avatar">प्र</div>
            <div className="sidebar-profile-info">
              <div className="sidebar-profile-name">मुख्य प्रशासक</div>
              <div className="sidebar-profile-role">सरपंच व ग्रामसेवक</div>
            </div>
          </div>

          <nav className="sidebar-nav">
            <div className="sidebar-nav-label">मुख्य मेनू</div>
            {MENU.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`sidebar-link ${isActive(item.path) ? "active" : ""}`}
              >
                <item.icon size={19} strokeWidth={1.9} />
                <span>{item.name}</span>
                {item.badge && pendingCount > 0 && (
                  <span className="sidebar-link-badge">{pendingCount}</span>
                )}
              </Link>
            ))}
          </nav>

          <div className="sidebar-footer">
            <button className="sidebar-logout" onClick={handleLogout}>
              <Icon.logout size={17} />
              <span>लॉगआउट</span>
            </button>
          </div>
        </aside>

        {/* ============ MAIN ============ */}
        <main className="admin-main">
          <header className="admin-topbar">
            <button
              className="topbar-toggle"
              onClick={() => setIsSidebarOpen((s) => !s)}
              aria-label="Toggle sidebar"
            >
              <Icon.menu size={18} />
            </button>

            <div className="topbar-breadcrumb">
              <span>मुख्यपृष्ठ</span>
              <Icon.arrowRight size={13} strokeWidth={2} />
              <b>{currentPage?.name || "डॅशबोर्ड"}</b>
            </div>

            <div className="topbar-actions">
              <button
                className="topbar-icon-btn"
                title="प्रलंबित सेवा अर्ज"
                onClick={() => navigate("/admin/services")}
              >
                <Icon.bell size={18} />
                {pendingCount > 0 && (
                  <span className="topbar-icon-dot">{pendingCount}</span>
                )}
              </button>

              <button
                className="topbar-website-btn"
                onClick={() => window.open("/", "_blank")}
              >
                <Icon.external size={16} />
                <span>वेबसाईट पहा</span>
              </button>
            </div>
          </header>

          <div className="admin-content">
            <Outlet context={{ greeting: getGreeting(), pendingCount, initialsOf }} />
          </div>
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
